<template>
    <div class="width-full">
        <v-container fluid grid-list-xl class="container-symptoms-questions general-container">
            <v-layout row wrap class="navigation-header">
                <v-flex xs12>
                    <header-bar-medical-device
                        :shortcut-nav="this.shortcutNav"
                        @setIsKeyboardNav="setIsKeyboardNav"
                        :title="text('api.pageTitle.assessmentSymptoms')" ref="headerMedical"></header-bar-medical-device>
                </v-flex>
            </v-layout>

            <div class="scrolling-content-symptoms-professional"
                 ref="symptomsQuestionsScrollingContentRef">
                <symptoms-questions-content ref="symptomsQuestionsContentRef"
                                            :shortcutNav="this.shortcutNav"
                                            @emitChangeAnswer="onChangeAnswer"
                                            @emitQuestionClick="onQuestionClick"
                                            @emitRelatedSymptomClick="onRelatedSymptomClick"
                                            @emitRelatedSymptomsPanelClick="onRelatedSymptomsPanelClick"
                                            @emitNoOtherSymptomsPanelClick="onNoOtherSymptomsPanelClick"
                                            @emitSymptomPanelClick="onSymptomPanelClick"
                                            @emitSharedQuestionsPanelClick="onSharedQuestionsPanelClick">
                </symptoms-questions-content>
            </div>
        </v-container>

        <v-footer app class="padding-left-xxl padding-right-xxl elevation-bg-color border-top-invisible">
            <v-layout row wrap>
                <v-flex text-xs-center>
                    <v-btn @click="gotoScoringPage()"
                           id="btnFinishAssessment"
                           class="footer-btn goToScoring"
                           :class="{'is-semi-target': isSemiTarget}"
                           flat
                    >
                        {{text('api.button.finish')}}
                        <finish-icon />
                    </v-btn>

                    <div class="footer-right-btns">
                        <v-btn flat @click="goToPreviousPage" id="btnGoToPrevAssessmentPage" class="footer-btn">
                            <arrow-left-icon />
                            {{ text('api.button.back') }}
                        </v-btn>
                        <v-btn color="primary"
                               @click="goToNextPage"
                               :loading="getPendingRequest"
                               :disabled="getPendingRequest"
                               id="btnEvaluateAssessment"
                               class="footer-btn footer-btn-next color-on-primary-text"
                               :class="{'is-semi-target grey--text text--darken-1': isSemiTarget}">
                            {{ text('api.button.evaluate')}}
                            <arrow-next-icon :svg-fill-class="'svg-on-primary-color'"/>
                        </v-btn>
                    </div>
                </v-flex>
            </v-layout>
        </v-footer>

        <div class="cookies-display">
            <detect-browser-cookie></detect-browser-cookie>
            <accept-cookie></accept-cookie>
        </div>

        <div v-if="getMustShowVitalParamsForm" class="vital-params-form-overlay overlay overlay--active"></div>
    </div>
</template>

<!-- ################################################################## -->

<script>
import HeaderBar from "../../shared/HeaderBar";
import TopBar from '../../../../common/components/shared/TopBar';

import AssessmentAlerts from "../../../../common/components/shared/AssessmentAlerts";
import PatientInfo from "../../../../common/components/shared/PatientInfo";

import SymptomsQuestionsContent from "./SymptomsQuestionsContent";
import SymptomsQuestionsContentListMode from "../symptoms-priority-list/SymptomsQuestionsContentListMode";
import AcceptCookie from '../../../../professional/components/cookies/AcceptCookie';
import HeaderBarMedicalDevice from "../../shared/HeaderBarMedicalDevice";
import DetectBrowserCookie from '../../../../common/components/cookies/DetectBrowserCookie';


import {mapActions, mapGetters} from 'vuex';
import FinishIcon from "../../../../common/components/svg/shared/finishIcon";
import ArrowLeftIcon from "../../../../common/components/svg/shared/arrowLeftIcon";
import ArrowNextIcon from "../../../../common/components/svg/shared/arrowNextIcon";

const SQ_PANEL = {
        RELATED_SYMPTOMS: "RELATED_SYMPTOMS",
        NO_OTHER_SYMPTOMS: "NO_OTHER_SYMPTOMS",
        SYMPTOMS_PANEL: "SYMPTOMS_PANEL",
        SHARED_QUESTIONS: "SHARED_QUESTIONS"
    };

    export default {
        name: 'SymptomsQuestionsPage',

        components: {
            ArrowNextIcon,
            ArrowLeftIcon,
            FinishIcon,
            SymptomsQuestionsContent,
            SymptomsQuestionsContentListMode,
            HeaderBar,
            TopBar,
            AssessmentAlerts,
            PatientInfo,
            AcceptCookie,
            HeaderBarMedicalDevice,
            DetectBrowserCookie
        },

        beforeCreate() {
            if (typeof this.$route.query.referral === "undefined" || this.$route.query.referral !== "testsTreeNode") {
                this.$store.commit('SymptomsQuestionsStore/resetStore');
                this.$store.commit('AssessmentAlertsStore/resetStore');
            }
        },

        created () {

            // If the url has param ?referral=testsTreeNode, that means that we are coming from tests tree,
            // so data for this page should be already loaded and must be kept and used.
            // Otherwise, (re)load data now.
            if (typeof this.$route.query.referral !== "undefined" && this.$route.query.referral === "testsTreeNode") {
                this.$router.replace({'referral': null});
            } else {
                let requestLoadSymptomsQuestionsData = this.$store.dispatch('SymptomsQuestionsStore/loadSymptomsQuestionsData');
                requestLoadSymptomsQuestionsData.catch((error) => {
                    // If no Main Symptom has been choosed yet (server sends {returnCode:205}), redirect to Assessment Start page.
                    if (typeof error.serverResponse !== "undefined"
                        && typeof error.serverResponse.data !== "undefined"
                        && typeof error.serverResponse.data.returnCode !== "undefined"
                        && error.serverResponse.data.returnCode === 205) {
                        this.$router.push('/assessment-start');
                    }
                });
            }

            window.addEventListener('keydown', this.handleKeyDowns);
            window.addEventListener('keyup', this.handleKeyUps);
            window.addEventListener('click', this.handleClicks);
        },

        destroyed() {
            window.removeEventListener('keydown', this.handleKeyDowns);
            window.removeEventListener('keyup', this.handleKeyUps);
            window.removeEventListener('click', this.handleClicks);
        },

        data() {
            return {
                tempPatientComment: "",
                showComment: false,

                shortcutNav: {

                    isKeyboardNav: false,
                    isPanelHighlight: false,

                    crtPanel: SQ_PANEL.RELATED_SYMPTOMS,
                    crtSymptom: null,
                    crtQuestion: null,

                    crtRelatedSymptom: null,
                    crtRelatedSymptomYes: true,
                    getShowUserComment: 'TranslationStore/getShowUserComment'

                },

                isKeyDown: {}

            };
        },

        computed: {
            ...mapGetters({
                isAdmin: 'UserStore/getIsAdmin',
                patientProfileData: 'AssessmentStartStore/getPatientProfileData',
                getIsQuestionListModeEnabled: 'SymptomsQuestionsStore/getIsQuestionListModeEnabled',
                getPendingRequest: 'SymptomsQuestionsStore/getPendingRequest',

                relatedSymptomList: 'SymptomsQuestionsStore/getRelatedSymptomList',
                symptomStates: 'SymptomsQuestionsStore/getRelatedSymptomStates',

                noOtherSymptomsCheck: 'SymptomsQuestionsStore/getNoOtherSymptomsCheck',
                symptomList: 'SymptomsQuestionsStore/getSelectedRelatedSymptomList',
                sharedQuestionList: 'SymptomsQuestionsStore/getSharedQuestionList',
                mustShowScoringPopup: 'AssessmentAlertsStore/getMustShowScoringPopup',
                mustShowUrgentPopup: 'AssessmentAlertsStore/getMustShowUrgentPopup',
                getSemiTarget: 'AssessmentAlertsStore/getSemiTarget',
                medicalStatuses: 'AssessmentAlertsStore/getMedicalStatuses',
                medicalStatus: 'AssessmentAlertsStore/getMedicalStatus',
                getMustShowAssessmentList: 'SymptomsQuestionsStore/getMustShowAssessmentList',
                getMustShowEvaluationPage: 'TranslationStore/getMustShowEvaluationPage',
                getShowUserComment: 'TranslationStore/getShowUserComment',
                getShowUserCommentShortcut: 'TranslationStore/getShowUserCommentShortcut',
                getMustShowVitalParamsForm: 'VitalParametersStore/getMustShowVitalParamsForm',
                mustShowInfoPopup: 'MedicalDeviceInfoStore/getMustShowMedicalDeviceInfoPopup'

            }),

            isQuestionListModeEnabled: {
                get() {
                    return this.$store.getters['SymptomsQuestionsStore/getIsQuestionListModeEnabled'];
                },
                set(isListModeNewValue) {
                    let requestLoadData;
                    if (isListModeNewValue === true) {
                        requestLoadData = this.$store.dispatch('SymptomsQuestionsStore/loadSymptomsQuestionsDataForListMode');
                    } else {
                        requestLoadData = this.$store.dispatch('SymptomsQuestionsStore/loadSymptomsQuestionsData');
                    }

                    requestLoadData.then(() => {
                        this.$store.commit('SymptomsQuestionsStore/setIsQuestionListModeEnabled', isListModeNewValue);
                    });
                }
            },
            mustShowCodes: {
                get() {
                    return this.$store.getters['UserStore/getDebugMustShowIds'];
                },
                set(newVal) {
                    this.$store.commit('UserStore/setDebugMustShowIds', newVal);
                }
            },

            isSemiTarget () {
                // I created a computed method to be useful if we will need to add a more complex condition
                // in order to visually mark the semiTarget attribute in the page (ex. buttons colors).
                return ((this.getSemiTarget === true) ? true : false);
            }
        },

        watch: {

            mustShowScoringPopup(newValue, oldValue) {
                this.navHandleDropdownsAfterClosingPopups(newValue);
            },

            mustShowUrgentPopup(newValue, oldValue) {
                this.navHandleDropdownsAfterClosingPopups(newValue);
            },

            getShowUserComment(newValue) {
                this.navHandleDropdownsAfterClosingPopups(newValue);
            },

            // When the user closes the vital parameters form, the dropdowns must be focused again.
            getMustShowVitalParamsForm(newValue) {
                this.navHandleDropdownsAfterClosingPopups(newValue);
            },

        },

        methods: {
            ...mapActions({
                showScoringPopup: 'AssessmentAlertsStore/showScoringPopup'
            }),
            setTemporaryPatientCommentValue() {
                this.tempPatientComment = this.patientProfileData.comment;

                // Place cursor at the end of the patient comment text
                let commentId = document.getElementById("comment");
                if (commentId != null) {

                    let commentLength = commentId.value.length;
                    commentId.selectionStart = commentLength;
                    commentId.selectionEnd = commentLength;
                }
            },

            isPatientCommentChanged: function () {
                return this.tempPatientComment !== this.patientProfileData.comment;
            },

            savePatientComment: function() {
                if (this.$refs.headerMedical.isPatientCommentChanged() && this.getShowUserCommentShortcut) {
                    this.$store.dispatch("AssessmentStartStore/submitPatientProfileComment", {
                        fieldName: "COMMENT",
                        fieldValue: this.patientProfileData.comment
                    });
                }
                this.showComment = false;
                this.$store.commit('TranslationStore/setShowUserComment', this.showComment);
                this.$store.commit('TranslationStore/setShowUserCommentShortcut', this.showComment);
            },


            goToPreviousPage() {
                this.$router.push('/main-symptom');
            },

            goToNextPage() {
                this.$store.commit('SymptomsQuestionsStore/setPendingRequest', true);

                let promiseEvaluateAssessment = this.$store.dispatch('EvaluationStore/evaluateAssessment', {
                        shortcutUsed: false
                    });
                promiseEvaluateAssessment.then((promise) => {
                    const promiseData = promise.data.data.EVALUATION_STATUS.hasScoringData;

                    if (promiseData && this.getMustShowEvaluationPage) {
                        this.$router.push('/evaluation', () => {
                            this.$store.commit('SymptomsQuestionsStore/setPendingRequest', false);
                        })
                    } else {
                        this.$router.push('/scoring', () => {
                            this.$store.commit('SymptomsQuestionsStore/setPendingRequest', false);
                        })
                    }

                    });
                    promiseEvaluateAssessment.catch(() => {
                        this.$store.commit('SymptomsQuestionsStore/setPendingRequest', false);
                        // @TODO This alert with static text is just a quick solution until we decide what to display to the user when the request wasn't successfully done. Need to replace alert() with something else and the text must use translation mechanism.
                        alert("Couldn't evaluate assessment. Please try again.");
                    });
            },
            gotoScoringPage(){
                let promiseEvaluateAssessment = this.$store.dispatch('EvaluationStore/evaluateAssessment', {
                    shortcutUsed: true
                });

                promiseEvaluateAssessment.then(() => {
                    this.$store.commit('ScoringStore/clearTestTreeData');
                    this.$router.push('/scoring');
                });
                promiseEvaluateAssessment.catch(() => {
                    // @TODO This alert with static text is just a quick solution until we decide what to display to the user when the request wasn't successfully done. Need to replace alert() with something else and the text must use translation mechanism.
                    alert("Couldn't evaluate assessment. Please try again.");
                });
            },


            /*******************************
             ***   KEYBOARD NAVIGATION   ***
             ***      BEGIN CODE         ***
             *******************************/

            setIsKeyboardNav(value) {
                this.shortcutNav.isKeyboardNav = value;
            },

            // Handle Key/Mouse

            handleKeyDowns(event) {

                if (this.mustShowUrgentPopup === true || this.getMustShowVitalParamsForm) {
                    return;
                }

                switch (event.keyCode) {

                    // Tab
                    case 9:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;

                    // Escape
                    case 27:
                        // Escape
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {
                            // If patient comment is shown, close it
                            if (this.getShowUserComment === true) {
                                this.savePatientComment();
                            }
                        }
                        break;

                    // M
                    case 77:
                        // ALT + M
                        if (event.shiftKey === false && event.altKey === true && event.ctrlKey === false) {
                            event.preventDefault();
                            event.stopPropagation();
                            event.stopImmediatePropagation();

                            // If the keyboard combination has been pressed while scoring popup is shown, then close scoring popup
                            if (this.mustShowScoringPopup === true) {
                                this.$store.commit('AssessmentAlertsStore/setMustShowScoringPopup', false);
                            }

                            if (this.mustShowInfoPopup === true) {
                                this.$store.commit('MedicalDeviceInfoStore/setMustShowMedicalDeviceInfoPopup', false);
                            }

                            if (this.vSelectCrtQuestion != null) {
                                this.vSelectCrtQuestion.hideMenu();
                            }

                            this.showComment = true;
                            this.$store.commit('TranslationStore/setShowUserComment', this.showComment);
                            this.$store.commit('TranslationStore/setShowUserCommentShortcut', this.showComment);
                        }
                        break;

                    // P
                    case 80:
                        // ALT + P
                        if (event.shiftKey === false && event.altKey === true && event.ctrlKey === false) {

                            if (this.medicalStatus === this.medicalStatuses.INFORMATION
                                || this.medicalStatus === this.medicalStatuses.URGENT) {

                                // for IE 11  - disable default behaviour
                                event.preventDefault();

                                if (this.mustShowInfoPopup === true) {
                                    this.$store.commit('MedicalDeviceInfoStore/setMustShowMedicalDeviceInfoPopup', false);
                                }

                                if (this.getShowUserComment === true) {
                                    this.savePatientComment();
                                }

                                if (this.vSelectCrtQuestion != null) {
                                    this.vSelectCrtQuestion.hideMenu();
                                }

                                this.showScoringPopup();
                            }
                        }
                        break;
                    // V
                    case 86:
                        // ALT + V
                        if (event.shiftKey === false && event.altKey === true && event.ctrlKey === false) {
                            // Prevent the default behavior
                            event.preventDefault();


                            // If the scoring popup is shown, then close it
                            if (this.mustShowScoringPopup === true) {
                                this.$store.commit('AssessmentAlertsStore/setMustShowScoringPopup', false);
                            }

                            // If the info popup is shown, then close it
                            if (this.mustShowInfoPopup === true) {
                                this.$store.commit('MedicalDeviceInfoStore/setMustShowMedicalDeviceInfoPopup', false);
                            }


                            // If we have a select menu open then close and blur it.
                            if (this.vSelectCrtQuestion != null) {
                                this.vSelectCrtQuestion.hideMenu();
                                this.vSelectCrtQuestion.$el.blur();
                            }

                            // Open the dropdown for the vital parameters
                            this.$store.commit('VitalParametersStore/setMustShowVitalParamsForm', true);

                            // Enable the keyboard navigation
                            this.shortcutNav.isKeyboardNav = true;
                        }

                        break;
                }

                if (this.mustShowScoringPopup === true || this.getShowUserComment === true || this.mustShowInfoPopup === true) {
                    return;
                }

                switch (event.keyCode) {

                    // Backspace
                    case 8:
                    // ALT
                    case 18:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;

                    // PageUp
                    case 33:
                        // PageUp
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {
                            event.preventDefault();
                            this.$refs["symptomsQuestionsScrollingContentRef"].scrollTop -= 50;
                        }
                        break;

                    // PageDown
                    case 34:
                        // PageDown
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {
                            event.preventDefault();
                            this.$refs["symptomsQuestionsScrollingContentRef"].scrollTop += 50;
                        }
                        break;

                    // Home
                    case 36:
                        // Shift + Home
                        if (event.ctrlKey === false && event.altKey === false && event.shiftKey === true) {
                            this.navGotoFirstPage();
                        }
                        break;

                    // ArrowLeft
                    case 37:
                    // ArrowUp
                    case 38:
                    // ArrowRight
                    case 39:
                    // ArrowDown
                    case 40:
                        event.preventDefault();
                        break;

                }

                //Prevent repeated calls for certain keys
                if (this.isKeyDown[event.keyCode] === true) {
                    return;
                }
                this.isKeyDown[event.keyCode] = true;

                let isVSelectOpen = this.vSelectCrtQuestion != null && this.vSelectCrtQuestion.menuIsActive === true;

                switch (event.keyCode) {

                    // Shift
                    case 16:
                        // SHIFT
                        event.preventDefault();
                        if (this.getShowUserComment === false) {
                            this.navEnablePanelHighlight();
                        }
                        break;

                    // PageUp
                    case 33:
                        // SHIFT + PageUp
                        if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {

                            this.goToPreviousPage()
                        }
                        break;

                    // PageDown
                    case 34:
                        // SHIFT + PageDown
                        if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {

                            this.goToNextPage();
                        }
                        break;

                    // End
                    case 35:
                        // SHIFT + End
                        if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {

                            this.gotoScoringPage();
                        }
                        break;

                    // ArrowLeft
                    case 37:

                        if (this.getShowUserComment === true) {
                            return;
                        }

                        this.navSetIsKeyboardNav(true);

                        // LEFT
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {

                            switch (this.shortcutNav.crtPanel) {
                                case SQ_PANEL.RELATED_SYMPTOMS:
                                    if (this.relatedSymptomList.length > 0) {

                                        if (this.shortcutNav.crtRelatedSymptom === null) {
                                            this.navSelectRelatedSymptom(0);
                                        }
                                        else {
                                            this.shortcutNav.crtRelatedSymptomYes = !this.shortcutNav.crtRelatedSymptomYes;
                                            this.navFindCheckboxRelatedSymptom(true);
                                        }
                                    }
                                    break;

                                case SQ_PANEL.SYMPTOMS_PANEL:
                                case SQ_PANEL.SHARED_QUESTIONS:
                                    break;
                            }
                        }
                        // CTRL + LEFT
                        else if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {

                            switch (this.shortcutNav.crtPanel) {
                                case SQ_PANEL.RELATED_SYMPTOMS:
                                    if (this.shortcutNav.crtRelatedSymptom === null) {
                                        this.navSelectRelatedSymptom(0);
                                    }
                                    else {
                                        this.shortcutNav.crtRelatedSymptomYes = true;
                                        this.navFindCheckboxRelatedSymptom(true);
                                    }
                                    break;

                            }
                        }
                        // SHIFT + LEFT
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {

                            // Medium and Up (> 960px)
                            // One column with RELATED_SYMPTOMS and possible NO_OTHER_SYMPTOMS
                            // Two or three columns with SYMPTOMS_PANEL
                            // One columns with SHARED_QUESTIONS
                            if (this.$vuetify.breakpoint.mdAndUp) {

                                switch (this.shortcutNav.crtPanel) {
                                    case SQ_PANEL.RELATED_SYMPTOMS:
                                    case SQ_PANEL.NO_OTHER_SYMPTOMS:
                                        this.navSelectPanelAndSharedQuestion(false);
                                        break;

                                    case SQ_PANEL.SYMPTOMS_PANEL:
                                        this.navSymptomsLeft();
                                        break;

                                    case SQ_PANEL.SHARED_QUESTIONS:
                                        this.navSetShortcutNavCrtPanel(SQ_PANEL.SYMPTOMS_PANEL, true);

                                        let symptomsListLength = this.symptomList.length;

                                        if (this.$vuetify.breakpoint.lgAndUp) {
                                            //We have 3 Symptoms at a row
                                            if (symptomsListLength >= 3) {
                                                this.navSelectSymptom(2);
                                            }
                                            else if (symptomsListLength === 2) {
                                                this.navSelectSymptom(1);
                                            }
                                            else {
                                                this.navSelectSymptom(0);
                                            }
                                        }
                                        else if (this.$vuetify.breakpoint.mdOnly) {
                                            //We have 2 Symptoms at a row
                                            if (symptomsListLength >= 2) {
                                                this.navSelectSymptom(1);
                                            }
                                            else {
                                                this.navSelectSymptom(0);
                                            }
                                        }
                                        break;
                                }
                            }
                            // Small (600px <-> 960px)
                            // One column with RELATED_SYMPTOMS and possible NO_OTHER_SYMPTOMS
                            // One columns with SYMPTOMS_PANEL and SHARED_QUESTIONS
                            else if (this.$vuetify.breakpoint.smOnly) {

                                switch (this.shortcutNav.crtPanel) {
                                    case SQ_PANEL.RELATED_SYMPTOMS:
                                    case SQ_PANEL.NO_OTHER_SYMPTOMS:
                                        this.navSetShortcutNavCrtPanel(SQ_PANEL.SYMPTOMS_PANEL, true);
                                        this.navSelectSymptom(0);
                                        break;

                                    case SQ_PANEL.SYMPTOMS_PANEL:
                                    case SQ_PANEL.SHARED_QUESTIONS:
                                        this.navSetShortcutNavCrtPanel(SQ_PANEL.RELATED_SYMPTOMS, true);
                                        break;
                                }
                            }
                            // Extra small (<600px)
                            // One column with RELATED_SYMPTOMS, possible NO_OTHER_SYMPTOMS, SYMPTOMS_PANEL and SHARED_QUESTIONS
                            else if (this.$vuetify.breakpoint.xsOnly) {

                                switch (this.shortcutNav.crtPanel) {
                                    case SQ_PANEL.RELATED_SYMPTOMS:
                                    case SQ_PANEL.NO_OTHER_SYMPTOMS:
                                    case SQ_PANEL.SYMPTOMS_PANEL:
                                    case SQ_PANEL.SHARED_QUESTIONS:
                                        break;
                                }
                            }

                        }
                        // SHIFT + CTRL + LEFT
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === true) {

                            // Medium and Up (> 960px)
                            // One column with RELATED_SYMPTOMS and possible NO_OTHER_SYMPTOMS
                            // Two or three columns with SYMPTOMS_PANEL
                            // One columns with SHARED_QUESTIONS
                            if (this.$vuetify.breakpoint.mdAndUp) {

                                switch (this.shortcutNav.crtPanel) {

                                    case SQ_PANEL.RELATED_SYMPTOMS:
                                    case SQ_PANEL.NO_OTHER_SYMPTOMS:
                                        break;

                                    case SQ_PANEL.SYMPTOMS_PANEL:
                                    case SQ_PANEL.SHARED_QUESTIONS:
                                        this.navSetShortcutNavCrtPanel(SQ_PANEL.RELATED_SYMPTOMS, true);
                                        break;
                                }
                            }
                            // Small (600px <-> 960px)
                            // One column with RELATED_SYMPTOMS and possible NO_OTHER_SYMPTOMS
                            // One columns with SYMPTOMS_PANEL and SHARED_QUESTIONS
                            else if (this.$vuetify.breakpoint.smOnly) {

                                switch (this.shortcutNav.crtPanel) {

                                    case SQ_PANEL.RELATED_SYMPTOMS:
                                    case SQ_PANEL.NO_OTHER_SYMPTOMS:
                                        break;

                                    case SQ_PANEL.SYMPTOMS_PANEL:
                                    case SQ_PANEL.SHARED_QUESTIONS:
                                        this.navSetShortcutNavCrtPanel(SQ_PANEL.RELATED_SYMPTOMS, true);
                                        break;
                                }
                            }
                        }
                        break;

                    // ArrowUp
                    case 38:

                        if (this.getShowUserComment === true) {
                            return;
                        }

                        this.navSetIsKeyboardNav(true);

                        // UP
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {

                            switch (this.shortcutNav.crtPanel) {

                                case SQ_PANEL.RELATED_SYMPTOMS:

                                    if (this.relatedSymptomList.length > 0) {

                                        if (this.shortcutNav.crtRelatedSymptom === null) {
                                            this.navSelectRelatedSymptom(0);
                                        }
                                        else {

                                            let currentRelatedSymptomIdx = this.navGetCurrentRelatedSymptomIdx();
                                            if (currentRelatedSymptomIdx < 0) {
                                                this.navSelectRelatedSymptom(0);
                                            }
                                            else if (currentRelatedSymptomIdx === 0) {
                                                this.navSelectRelatedSymptom(this.relatedSymptomList.length - 1);
                                            }
                                            else {
                                                this.navSelectRelatedSymptom(currentRelatedSymptomIdx - 1);
                                            }

                                        }
                                    }
                                    break;

                                case SQ_PANEL.SYMPTOMS_PANEL:
                                    if (isVSelectOpen === false) {
                                        this.navSpecificQuestionsUp();
                                        this.navScrollIntoViewCrtQuestion();
                                    }
                                    break;

                                case SQ_PANEL.SHARED_QUESTIONS:
                                    if (isVSelectOpen === false) {
                                        this.navSharedQuestionsUp();
                                        this.navScrollIntoViewCrtQuestion();
                                    }
                                    break;
                            }
                        }
                        // CTRL + UP
                        else if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {

                            switch (this.shortcutNav.crtPanel) {
                                case SQ_PANEL.RELATED_SYMPTOMS:
                                    if (this.relatedSymptomList.length > 0) {
                                        this.navSelectRelatedSymptom(0);
                                    }
                                    break;

                                case SQ_PANEL.SYMPTOMS_PANEL:
                                    if (isVSelectOpen === false) {
                                        this.navSpecificQuestionsTop();
                                        this.navScrollIntoViewCrtQuestion();
                                    }
                                    break;

                                case SQ_PANEL.SHARED_QUESTIONS:
                                    if (isVSelectOpen === false) {
                                        this.navSharedQuestionsTop();
                                        this.navScrollIntoViewCrtQuestion();
                                    }
                                    break;
                            }
                        }
                        // SHIFT + UP
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {

                            // Medium and Up (> 960px)
                            // One column with RELATED_SYMPTOMS and possible NO_OTHER_SYMPTOMS
                            // Two or three columns with SYMPTOMS_PANEL
                            // One columns with SHARED_QUESTIONS
                            if (this.$vuetify.breakpoint.mdAndUp) {

                                switch (this.shortcutNav.crtPanel) {
                                    case SQ_PANEL.RELATED_SYMPTOMS:
                                        if (this.noOtherSymptomsCheck === true) {
                                            this.navSetShortcutNavCrtPanel(SQ_PANEL.NO_OTHER_SYMPTOMS, true);
                                        }
                                        break;

                                    case SQ_PANEL.NO_OTHER_SYMPTOMS:
                                        this.navSetShortcutNavCrtPanel(SQ_PANEL.RELATED_SYMPTOMS, true);
                                        break;

                                    case SQ_PANEL.SYMPTOMS_PANEL:
                                        this.navSymptomsUp();
                                        break;

                                    case SQ_PANEL.SHARED_QUESTIONS:
                                        break;
                                }
                            }
                            // Small (600px <-> 960px)
                            // One column with RELATED_SYMPTOMS and possible NO_OTHER_SYMPTOMS
                            // One columns with SYMPTOMS_PANEL and SHARED_QUESTIONS
                            else if (this.$vuetify.breakpoint.smOnly) {

                                switch (this.shortcutNav.crtPanel) {
                                    case SQ_PANEL.RELATED_SYMPTOMS:
                                        if (this.noOtherSymptomsCheck === true) {
                                            this.navSetShortcutNavCrtPanel(SQ_PANEL.NO_OTHER_SYMPTOMS, true);
                                        }
                                        break;

                                    case SQ_PANEL.NO_OTHER_SYMPTOMS:
                                        this.navSetShortcutNavCrtPanel(SQ_PANEL.RELATED_SYMPTOMS, true);
                                        break;

                                    case SQ_PANEL.SYMPTOMS_PANEL:
                                        this.navSymptomsUp();
                                        break;

                                    case SQ_PANEL.SHARED_QUESTIONS:
                                        this.navSetShortcutNavCrtPanel(SQ_PANEL.SYMPTOMS_PANEL, true);
                                        this.navSelectSymptom(this.symptomList.length - 1);
                                        break;
                                }
                            }
                            // Extra small (<600px)
                            // One column with RELATED_SYMPTOMS, possible NO_OTHER_SYMPTOMS, SYMPTOMS_PANEL and SHARED_QUESTIONS
                            else if (this.$vuetify.breakpoint.xsOnly) {

                                switch (this.shortcutNav.crtPanel) {
                                    case SQ_PANEL.RELATED_SYMPTOMS:
                                        this.navSelectPanelAndSharedQuestion(false);
                                        break;

                                    case SQ_PANEL.NO_OTHER_SYMPTOMS:
                                        this.navSetShortcutNavCrtPanel(SQ_PANEL.RELATED_SYMPTOMS, true);
                                        break;

                                    case SQ_PANEL.SYMPTOMS_PANEL:
                                        this.navSymptomsUp();
                                        break;

                                    case SQ_PANEL.SHARED_QUESTIONS:
                                        this.navSetShortcutNavCrtPanel(SQ_PANEL.SYMPTOMS_PANEL, true);
                                        this.navSelectSymptom(this.symptomList.length - 1);
                                        break;
                                }
                            }

                        }
                        // SHIFT + CTRL + UP
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === true) {

                            // Medium and Up (> 960px)
                            // One column with RELATED_SYMPTOMS and possible NO_OTHER_SYMPTOMS
                            // Two or three columns with SYMPTOMS_PANEL
                            // One columns with SHARED_QUESTIONS
                            if (this.$vuetify.breakpoint.mdAndUp) {

                                switch (this.shortcutNav.crtPanel) {
                                    case SQ_PANEL.RELATED_SYMPTOMS:
                                        break;

                                    case SQ_PANEL.NO_OTHER_SYMPTOMS:
                                        this.navSetShortcutNavCrtPanel(SQ_PANEL.RELATED_SYMPTOMS, true);
                                        break;

                                    case SQ_PANEL.SYMPTOMS_PANEL:
                                        this.navSymptomsMdAndUpTop();
                                        break;

                                    case SQ_PANEL.SHARED_QUESTIONS:
                                        break;
                                }
                            }
                            // Small (600px <-> 960px)
                            // One column with RELATED_SYMPTOMS and possible NO_OTHER_SYMPTOMS
                            // One columns with SYMPTOMS_PANEL and SHARED_QUESTIONS
                            else if (this.$vuetify.breakpoint.smOnly) {

                                switch (this.shortcutNav.crtPanel) {
                                    case SQ_PANEL.RELATED_SYMPTOMS:
                                        break;

                                    case SQ_PANEL.NO_OTHER_SYMPTOMS:
                                        this.navSetShortcutNavCrtPanel(SQ_PANEL.RELATED_SYMPTOMS, true);
                                        break;

                                    case SQ_PANEL.SYMPTOMS_PANEL:
                                        this.navSelectSymptom(0);
                                        break;

                                    case SQ_PANEL.SHARED_QUESTIONS:
                                        this.navSetShortcutNavCrtPanel(SQ_PANEL.SYMPTOMS_PANEL, true);
                                        this.navSelectSymptom(0);
                                        break;
                                }
                            }
                            // Extra small (<600px)
                            // One column with RELATED_SYMPTOMS, possible NO_OTHER_SYMPTOMS, SYMPTOMS_PANEL and SHARED_QUESTIONS
                            else if (this.$vuetify.breakpoint.xsOnly) {

                                this.navSetShortcutNavCrtPanel(SQ_PANEL.RELATED_SYMPTOMS, true);
                            }
                        }
                        break;

                    // ArrowRight
                    case 39:

                        if (this.getShowUserComment === true) {
                            return;
                        }

                        this.navSetIsKeyboardNav(true);

                        // RIGHT
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {

                            switch (this.shortcutNav.crtPanel) {
                                case SQ_PANEL.RELATED_SYMPTOMS:
                                    if (this.relatedSymptomList.length > 0) {

                                        if (this.shortcutNav.crtRelatedSymptom === null) {
                                            this.navSelectRelatedSymptom(0);
                                        }
                                        else {
                                            this.shortcutNav.crtRelatedSymptomYes = !this.shortcutNav.crtRelatedSymptomYes;
                                            this.navFindCheckboxRelatedSymptom(true);
                                        }
                                    }
                                    break;

                                case SQ_PANEL.SYMPTOMS_PANEL:
                                case SQ_PANEL.SHARED_QUESTIONS:
                                    break;
                            }
                        }
                        // CTRL + RIGHT
                        else if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {

                            switch (this.shortcutNav.crtPanel) {
                                case SQ_PANEL.RELATED_SYMPTOMS:
                                    if (this.shortcutNav.crtRelatedSymptom === null) {
                                        this.navSelectRelatedSymptom(0);
                                    }
                                    else {
                                        this.shortcutNav.crtRelatedSymptomYes = false;
                                        this.navFindCheckboxRelatedSymptom(true);
                                    }
                                    break;
                            }
                        }
                        // SHIFT + RIGHT
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {

                            // Medium and Up (> 960px)
                            // One column with RELATED_SYMPTOMS and possible NO_OTHER_SYMPTOMS
                            // Two or three columns with SYMPTOMS_PANEL
                            // One columns with SHARED_QUESTIONS
                            if (this.$vuetify.breakpoint.mdAndUp) {

                                switch (this.shortcutNav.crtPanel) {
                                    case SQ_PANEL.RELATED_SYMPTOMS:
                                    case SQ_PANEL.NO_OTHER_SYMPTOMS:
                                        this.navSetShortcutNavCrtPanel(SQ_PANEL.SYMPTOMS_PANEL, true);
                                        this.navSelectSymptom(0);
                                        break;

                                    case SQ_PANEL.SYMPTOMS_PANEL:
                                        this.navSymptomsRight();
                                        break;

                                    case SQ_PANEL.SHARED_QUESTIONS:
                                        this.navSetShortcutNavCrtPanel(SQ_PANEL.RELATED_SYMPTOMS, true);
                                        break;
                                }
                            }
                            // Small (600px <-> 960px)
                            // One column with RELATED_SYMPTOMS and possible NO_OTHER_SYMPTOMS
                            // One columns with SYMPTOMS_PANEL and SHARED_QUESTIONS
                            else if (this.$vuetify.breakpoint.smOnly) {

                                switch (this.shortcutNav.crtPanel) {
                                    case SQ_PANEL.RELATED_SYMPTOMS:
                                    case SQ_PANEL.NO_OTHER_SYMPTOMS:
                                        this.navSetShortcutNavCrtPanel(SQ_PANEL.SYMPTOMS_PANEL, true);
                                        this.navSelectSymptom(0);
                                        break;

                                    case SQ_PANEL.SYMPTOMS_PANEL:
                                    case SQ_PANEL.SHARED_QUESTIONS:
                                        this.navSetShortcutNavCrtPanel(SQ_PANEL.RELATED_SYMPTOMS, true);
                                        break;
                                }
                            }
                            // Extra small (<600px)
                            // One column with RELATED_SYMPTOMS, possible NO_OTHER_SYMPTOMS, SYMPTOMS_PANEL and SHARED_QUESTIONS
                            else if (this.$vuetify.breakpoint.xsOnly) {

                                switch (this.shortcutNav.crtPanel) {
                                    case SQ_PANEL.RELATED_SYMPTOMS:
                                    case SQ_PANEL.NO_OTHER_SYMPTOMS:
                                    case SQ_PANEL.SYMPTOMS_PANEL:
                                    case SQ_PANEL.SHARED_QUESTIONS:
                                        break;
                                }
                            }

                        }
                        // SHIFT + CTRL + RIGHT
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === true) {

                            // Medium and Up (> 960px)
                            // One column with RELATED_SYMPTOMS and possible NO_OTHER_SYMPTOMS
                            // Two or three columns with SYMPTOMS_PANEL
                            // One columns with SHARED_QUESTIONS
                            if (this.$vuetify.breakpoint.mdAndUp) {

                                switch (this.shortcutNav.crtPanel) {

                                    case SQ_PANEL.RELATED_SYMPTOMS:
                                    case SQ_PANEL.NO_OTHER_SYMPTOMS:
                                    case SQ_PANEL.SYMPTOMS_PANEL:
                                        this.navSelectPanelAndSharedQuestion(false);
                                        break;

                                    case SQ_PANEL.SHARED_QUESTIONS:
                                        break;
                                }
                            }
                            // Small (600px <-> 960px)
                            // One column with RELATED_SYMPTOMS and possible NO_OTHER_SYMPTOMS
                            // One columns with SYMPTOMS_PANEL and SHARED_QUESTIONS
                            else if (this.$vuetify.breakpoint.smOnly) {

                                switch (this.shortcutNav.crtPanel) {

                                    case SQ_PANEL.RELATED_SYMPTOMS:
                                    case SQ_PANEL.NO_OTHER_SYMPTOMS:
                                        this.navSetShortcutNavCrtPanel(SQ_PANEL.SYMPTOMS_PANEL, true);
                                        this.navSelectSymptom(0);
                                        break;

                                    case SQ_PANEL.SYMPTOMS_PANEL:
                                    case SQ_PANEL.SHARED_QUESTIONS:
                                        break;
                                }
                            }

                        }
                        break;

                    // ArrowDown
                    case 40:

                        if (this.getShowUserComment === true) {
                            return;
                        }

                        this.navSetIsKeyboardNav(true);

                        // DOWN
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {

                            switch (this.shortcutNav.crtPanel) {
                                case SQ_PANEL.RELATED_SYMPTOMS:

                                    if (this.relatedSymptomList.length > 0) {

                                        if (this.shortcutNav.crtRelatedSymptom === null) {
                                            this.navSelectRelatedSymptom(0);
                                        }
                                        else {

                                            let currentRelatedSymptomIdx = this.navGetCurrentRelatedSymptomIdx();
                                            if (currentRelatedSymptomIdx < 0) {
                                                this.navSelectRelatedSymptom(0);
                                            }
                                            else if (currentRelatedSymptomIdx === (this.relatedSymptomList.length - 1)) {
                                                this.navSelectRelatedSymptom(0);
                                            }
                                            else {
                                                this.navSelectRelatedSymptom(currentRelatedSymptomIdx + 1);
                                            }

                                        }
                                    }
                                    break;

                                case SQ_PANEL.SYMPTOMS_PANEL:
                                    if (isVSelectOpen === false) {
                                        this.navSpecificQuestionsDown();
                                        this.navScrollIntoViewCrtQuestion();
                                    }
                                    break;

                                case SQ_PANEL.SHARED_QUESTIONS:
                                    if (isVSelectOpen === false) {
                                        this.navSharedQuestionsDown();
                                        this.navScrollIntoViewCrtQuestion();
                                    }
                                    break;
                            }
                        }
                        // CTRL + DOWN
                        else if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {

                            switch (this.shortcutNav.crtPanel) {
                                case SQ_PANEL.RELATED_SYMPTOMS:
                                    if (this.relatedSymptomList.length > 0) {
                                        this.navSelectRelatedSymptom(this.relatedSymptomList.length - 1);
                                    }
                                    break;

                                case SQ_PANEL.SYMPTOMS_PANEL:
                                    if (isVSelectOpen === false) {
                                        this.navSpecificQuestionsBottom();
                                        this.navScrollIntoViewCrtQuestion();
                                    }
                                    break;

                                case SQ_PANEL.SHARED_QUESTIONS:
                                    if (isVSelectOpen === false) {
                                        this.navSharedQuestionsBottom();
                                        this.navScrollIntoViewCrtQuestion();
                                    }
                                    break;
                            }
                        }
                        // SHIFT + DOWN
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {

                            // Medium and Up (> 960px)
                            // One column with RELATED_SYMPTOMS and possible NO_OTHER_SYMPTOMS
                            // Two or three columns with SYMPTOMS_PANEL
                            // One columns with SHARED_QUESTIONS
                            if (this.$vuetify.breakpoint.mdAndUp) {

                                switch (this.shortcutNav.crtPanel) {
                                    case SQ_PANEL.RELATED_SYMPTOMS:
                                        if (this.noOtherSymptomsCheck === true) {
                                            this.navSetShortcutNavCrtPanel(SQ_PANEL.NO_OTHER_SYMPTOMS, true);
                                        }
                                        break;

                                    case SQ_PANEL.NO_OTHER_SYMPTOMS:
                                        this.navSetShortcutNavCrtPanel(SQ_PANEL.RELATED_SYMPTOMS, true);
                                        break;

                                    case SQ_PANEL.SYMPTOMS_PANEL:
                                        this.navSymptomsDown();
                                        break;

                                    case SQ_PANEL.SHARED_QUESTIONS:
                                        break;
                                }
                            }
                            // Small (600px <-> 960px)
                            // One column with RELATED_SYMPTOMS and possible NO_OTHER_SYMPTOMS
                            // One columns with SYMPTOMS_PANEL and SHARED_QUESTIONS
                            else if (this.$vuetify.breakpoint.smOnly) {

                                switch (this.shortcutNav.crtPanel) {
                                    case SQ_PANEL.RELATED_SYMPTOMS:
                                        if (this.noOtherSymptomsCheck === true) {
                                            this.navSetShortcutNavCrtPanel(SQ_PANEL.NO_OTHER_SYMPTOMS, true);
                                        }
                                        break;

                                    case SQ_PANEL.NO_OTHER_SYMPTOMS:
                                        this.navSetShortcutNavCrtPanel(SQ_PANEL.RELATED_SYMPTOMS, true);
                                        break;

                                    case SQ_PANEL.SYMPTOMS_PANEL:
                                        this.navSymptomsDown();
                                        break;

                                    case SQ_PANEL.SHARED_QUESTIONS:
                                        this.navSetShortcutNavCrtPanel(SQ_PANEL.SYMPTOMS_PANEL, true);
                                        this.navSelectSymptom(0);
                                        break;
                                }
                            }
                            // Extra small (<600px)
                            // One column with RELATED_SYMPTOMS, possible NO_OTHER_SYMPTOMS, SYMPTOMS_PANEL and SHARED_QUESTIONS
                            else if (this.$vuetify.breakpoint.xsOnly) {

                                switch (this.shortcutNav.crtPanel) {
                                    case SQ_PANEL.RELATED_SYMPTOMS:
                                        if (this.noOtherSymptomsCheck === true) {
                                            this.navSetShortcutNavCrtPanel(SQ_PANEL.NO_OTHER_SYMPTOMS, true);
                                        }
                                        else {
                                            this.navSetShortcutNavCrtPanel(SQ_PANEL.SYMPTOMS_PANEL, true);
                                            this.navSelectSymptom(0);
                                        }
                                        break;

                                    case SQ_PANEL.NO_OTHER_SYMPTOMS:
                                        this.navSetShortcutNavCrtPanel(SQ_PANEL.SYMPTOMS_PANEL, true);
                                        this.navSelectSymptom(0);
                                        break;

                                    case SQ_PANEL.SYMPTOMS_PANEL:
                                        this.navSymptomsDown();
                                        break;

                                    case SQ_PANEL.SHARED_QUESTIONS:
                                        this.navSetShortcutNavCrtPanel(SQ_PANEL.RELATED_SYMPTOMS, true);
                                        break;
                                }
                            }
                        }
                        // SHIFT + CTRL + DOWN
                        else if (event.shiftKey === true && event.altKey === false && event.ctrlKey === true) {

                            // Medium and Up (> 960px)
                            // One column with RELATED_SYMPTOMS and possible NO_OTHER_SYMPTOMS
                            // Two or three columns with SYMPTOMS_PANEL
                            // One columns with SHARED_QUESTIONS
                            if (this.$vuetify.breakpoint.mdAndUp) {

                                switch (this.shortcutNav.crtPanel) {
                                    case SQ_PANEL.RELATED_SYMPTOMS:
                                        if (this.noOtherSymptomsCheck === true) {
                                            this.navSetShortcutNavCrtPanel(SQ_PANEL.NO_OTHER_SYMPTOMS, true);
                                        }
                                        break;

                                    case SQ_PANEL.NO_OTHER_SYMPTOMS:
                                        break;

                                    case SQ_PANEL.SYMPTOMS_PANEL:
                                        this.navSymptomsMdAndUpBottom();
                                        break;

                                    case SQ_PANEL.SHARED_QUESTIONS:
                                        break;
                                }
                            }
                            // Small (600px <-> 960px)
                            // One column with RELATED_SYMPTOMS and possible NO_OTHER_SYMPTOMS
                            // One columns with SYMPTOMS_PANEL and SHARED_QUESTIONS
                            else if (this.$vuetify.breakpoint.smOnly) {

                                switch (this.shortcutNav.crtPanel) {
                                    case SQ_PANEL.RELATED_SYMPTOMS:
                                        if (this.noOtherSymptomsCheck === true) {
                                            this.navSetShortcutNavCrtPanel(SQ_PANEL.NO_OTHER_SYMPTOMS, true);
                                        }
                                        break;

                                    case SQ_PANEL.NO_OTHER_SYMPTOMS:
                                        break;

                                    case SQ_PANEL.SYMPTOMS_PANEL:
                                        this.navSelectPanelAndSharedQuestion(false);
                                        break;

                                    case SQ_PANEL.SHARED_QUESTIONS:
                                        break;
                                }
                            }
                            // Extra small (<600px)
                            // One column with RELATED_SYMPTOMS, possible NO_OTHER_SYMPTOMS, SYMPTOMS_PANEL and SHARED_QUESTIONS
                            else if (this.$vuetify.breakpoint.xsOnly) {

                                this.navSelectPanelAndSharedQuestion(false);
                            }
                        }
                        break;
                }
            },

            handleKeyUps(event) {

                this.isKeyDown[event.keyCode] = false;

                if (this.mustShowScoringPopup === true || this.mustShowUrgentPopup === true || this.mustShowInfoPopup === true || this.getMustShowVitalParamsForm === true) {
                    return;
                }

                switch (event.keyCode) {

                    // Tab
                    case 9:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;

                    // Enter
                    case 13:
                        // Ctrl + Enter
                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {
                            event.preventDefault();
                            event.stopPropagation();
                            event.stopImmediatePropagation();

                            // Close the patient comment popup on Ctrl + Enter
                            if (this.getShowUserComment === true) {
                                this.savePatientComment();
                                this.navSetIsKeyboardNav(true);
                            }
                        }
                        break;

                    // Shift
                    case 16:
                        if (this.getShowUserComment === false) {
                            event.preventDefault();
                            this.navDisablePanelHighlight();
                            this.navFocusPanelElement();
                        }
                        break;

                    // ALT
                    case 18:
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;

                }
            },

            handleClicks(event) {
                this.shortcutNav.isKeyboardNav = false;
            },

            // On Events

            onChangeAnswer(data) {

                if (this.shortcutNav.isKeyboardNav === false) {
                    return;
                }

                // If we get Urgent Popup, don't navigate to the next unanswered Question
                // Must set also the Focus on the Dropdown when return from Urgent Popup
                if (this.mustShowUrgentPopup === true) {
                    return;
                }

                if (this.shortcutNav.crtPanel === SQ_PANEL.SYMPTOMS_PANEL) {

                    let currentSymptomIdx = this.navGetCurrentSymptomIdx();
                    if (currentSymptomIdx < 0) {
                        this.navSelectSymptom(0);
                        return;
                    }

                    let currentSymptom = this.symptomList[currentSymptomIdx];

                    if (currentSymptom === null || typeof (currentSymptom.questionsData.questions) === "undefined") {
                        return;
                    }

                    let symptomQuestionsList = currentSymptom.questionsData.questions;
                    let answeredQIdx = symptomQuestionsList.findIndex((currentQuestion) => {
                        return (currentQuestion.code === data.questionCode);
                    });

                    //Find first Unanswered Q (if exists)
                    let nextUnansweredQIdx = symptomQuestionsList.findIndex((currentQuestion, crtIndex) => {
                        return (crtIndex >  answeredQIdx && currentQuestion.providedAnswer === null);
                    });

                    if (nextUnansweredQIdx >= 0) {
                        this.navSelectSymptomAndQuestion(currentSymptomIdx, nextUnansweredQIdx, true);
                    }
                    else if (currentSymptomIdx === (this.symptomList.length - 1)) {
                        this.navSelectFirstShQOrFirstUnansweredSpQFromBegining();
                    }
                    else {
                        // Continue to the next symptoms and search if there are still not answered Q
                        let firstUnansweredSpQArr = this.navGetFirstUnansweredSpQ(currentSymptomIdx);

                        if (firstUnansweredSpQArr != null) {

                            this.navSelectSymptomAndQuestion(firstUnansweredSpQArr[0], firstUnansweredSpQArr[1], true);
                        }
                        else {
                            this.navSelectFirstShQOrFirstUnansweredSpQFromBegining();
                        }

                    }
                }
                else if (this.shortcutNav.crtPanel === SQ_PANEL.SHARED_QUESTIONS) {

                    let answeredQIdx = this.sharedQuestionList.findIndex((currentQuestion) => {
                        return (currentQuestion.code === data.questionCode);
                    });

                    //Find first Unanswered Q (if exists)
                    let nextUnansweredQIdx = this.sharedQuestionList.findIndex((currentQuestion, crtIndex) => {
                        return (crtIndex >  answeredQIdx && currentQuestion.providedAnswer === null);
                    });

                    if (nextUnansweredQIdx >= 0) {
                        this.navSelectSharedQuestion(nextUnansweredQIdx, true);
                    }
                    else {
                        // Continue to the next symptoms and search if there are still not answered Q
                        let firstUnansweredSpQArr = this.navGetFirstUnansweredSpQ();

                        if (firstUnansweredSpQArr != null) {

                            this.navSelectSymptomAndQuestion(firstUnansweredSpQArr[0], firstUnansweredSpQArr[1], true);
                        }
                        else {

                            //Find first Unanswered Q (if exists)
                            let nextUnansweredQIdx = this.sharedQuestionList.findIndex((currentQuestion, crtIndex) => {
                                return (currentQuestion.providedAnswer === null);
                            });

                            if (nextUnansweredQIdx >= 0) {
                                this.navSelectSharedQuestion(nextUnansweredQIdx, true);
                            }
                            else {
                                //Stay on the last answered
                            }
                        }
                    }
                }

            },

            onQuestionClick(data) {

                if (data === null || data.crtPanel === null || data.questionCode === null) {
                    return;
                }

                this.navSetShortcutNavCrtPanel(data.crtPanel, false);

                this.shortcutNav.crtQuestion = data.questionCode;

                if (data.crtPanel === SQ_PANEL.SYMPTOMS_PANEL) {
                    this.shortcutNav.crtSymptom = data.symptomCode;

                    this.navSetVSelectCrtQuestionForSpecificQ();
                }
                else if (data.crtPanel === SQ_PANEL.SHARED_QUESTIONS) {

                    this.navSetVSelectCrtQuestionForSharedQ();
                }

            },

            onRelatedSymptomClick(data) {

                if (data.symptomCode === null || data.symptomYes === null) {
                    return;
                }

                this.navSetShortcutNavCrtPanel(SQ_PANEL.RELATED_SYMPTOMS, false);

                this.shortcutNav.crtRelatedSymptom = data.symptomCode;
                this.shortcutNav.crtRelatedSymptomYes = data.symptomYes;

                this.navFindCheckboxRelatedSymptom(false);

            },

            onRelatedSymptomsPanelClick() {

                this.navSetShortcutNavCrtPanel(SQ_PANEL.RELATED_SYMPTOMS, false);

                if (this.shortcutNav.crtRelatedSymptom === null && this.relatedSymptomList.length > 0) {

                    this.shortcutNav.crtRelatedSymptom = this.relatedSymptomList[0].code;

                    this.navFindCheckboxRelatedSymptom(false);
                }
            },

            onNoOtherSymptomsPanelClick() {
                this.navSetShortcutNavCrtPanel(SQ_PANEL.NO_OTHER_SYMPTOMS, false);
            },

            onSymptomPanelClick(data) {

                if (data.symptomCode === null) {
                    return;
                }

                this.navSetShortcutNavCrtPanel(SQ_PANEL.SYMPTOMS_PANEL, false);

                if (this.shortcutNav.crtSymptom === data.symptomCode) {
                    return;
                }

                this.shortcutNav.crtSymptom = data.symptomCode;

                let currentSymptomIdx = this.navGetCurrentSymptomIdx();
                if (currentSymptomIdx < 0) {
                    currentSymptomIdx = 0;
                }

                let symptom = this.symptomList[currentSymptomIdx];

                let symptomQuestionList = symptom.questionsData.questions;
                if (symptomQuestionList.length === 0) {
                    return;
                }

                let selectQuestionIdx = symptomQuestionList.findIndex((currentQuestion, currentIndex) => {
                    if (currentQuestion.providedAnswer === null) {
                        return true;
                    }
                });

                if (selectQuestionIdx < 0) {
                    selectQuestionIdx = 0;
                }

                this.shortcutNav.crtQuestion = symptomQuestionList[selectQuestionIdx].code;

                this.navSetVSelectCrtQuestionForSpecificQ();

            },

            onSharedQuestionsPanelClick() {

                if (this.shortcutNav.crtPanel === SQ_PANEL.SHARED_QUESTIONS) {
                    return;
                }

                this.navSetShortcutNavCrtPanel(SQ_PANEL.SHARED_QUESTIONS, false);

                if (this.sharedQuestionList.length === 0) {
                    return;
                }

                let selectQuestionIdx = this.sharedQuestionList.findIndex((currentQuestion, crtIndex) => {
                    if (currentQuestion.providedAnswer === null) {
                        return true;
                    }
                });

                if (selectQuestionIdx < 0) {
                    selectQuestionIdx = 0;
                }

                this.shortcutNav.crtQuestion = this.sharedQuestionList[selectQuestionIdx].code;

                this.navSetVSelectCrtQuestionForSharedQ();

            },

            // Panel Highlight Enable/Disable

            navEnablePanelHighlight() {

                this.shortcutNav.isPanelHighlight = true;
                this.shortcutNav.isKeyboardNav = true;

                //Wait for the completion of the answers animation
                setTimeout(() => {
                    if (this.vSelectCrtQuestion != null) {
                        this.vSelectCrtQuestion.hideMenu();
                    }
                },75);

                //left outside the timeout otherwise it will not scroll
                //if the shift button is released immediately after being pressed
                this.navScrollIntoViewPanelOrSymptoms();
            },

            navDisablePanelHighlight() {

                this.shortcutNav.isPanelHighlight = false;
            },

            navFocusPanelElement() {

                switch (this.shortcutNav.crtPanel) {

                    case SQ_PANEL.RELATED_SYMPTOMS:
                        if (this.relatedSymptomList.length > 0) {
                            if (this.shortcutNav.crtRelatedSymptom === null) {
                                this.navSelectRelatedSymptom(0);
                            }
                            else {
                                let relatedSymptomIdx = this.navGetCurrentRelatedSymptomIdx();
                                if (relatedSymptomIdx >= 0) {
                                    this.navFindCheckboxRelatedSymptom(true);
                                }
                                else {
                                    this.navSelectRelatedSymptom(0);
                                }
                            }
                        }
                        break;

                    case SQ_PANEL.NO_OTHER_SYMPTOMS:

                        this.navFindCheckboxNoOtherSymptoms(true);
                        break;

                    case SQ_PANEL.SYMPTOMS_PANEL:
                    case SQ_PANEL.SHARED_QUESTIONS:

                        if (this.vSelectCrtQuestion != null) {
                            this.vSelectCrtQuestion.$el.focus();
                            this.navScrollIntoViewCrtQuestion();
                        }
                        break;
                }

            },

            navHandleDropdownsAfterClosingPopups(newValue) {

                if (this.shortcutNav.isKeyboardNav === false) {
                    return;
                }

                if (newValue === false) {

                    switch (this.shortcutNav.crtPanel) {

                        case SQ_PANEL.RELATED_SYMPTOMS:
                            this.navFindCheckboxRelatedSymptom(true);
                            break;

                        case SQ_PANEL.NO_OTHER_SYMPTOMS:
                            this.navFindCheckboxNoOtherSymptoms(true);
                            break;

                        case SQ_PANEL.SYMPTOMS_PANEL:
                        case SQ_PANEL.SHARED_QUESTIONS:
                            if (this.vSelectCrtQuestion != null) {
                                this.vSelectCrtQuestion.$el.focus();
                                this.navScrollIntoViewCrtQuestion();
                            }
                            break;

                    }
                }
            },

            // Change current panel

            navSetShortcutNavCrtPanel(crtPanelNew, isScrollIntoView) {

                let crtPanelOld = this.shortcutNav.crtPanel;
                this.shortcutNav.crtPanel = crtPanelNew;

                if (isScrollIntoView === true) {
                    this.navScrollIntoViewPanelOrSymptoms();
                }

                // We make actions only if the actual panel changed
                if (crtPanelOld !== crtPanelNew) {

                    switch (crtPanelOld) {

                        case SQ_PANEL.RELATED_SYMPTOMS:
                            if (this.checkboxRelatedSymptom != null) {
                                this.checkboxRelatedSymptom.$el.blur();
                            }
                            break;

                        case SQ_PANEL.NO_OTHER_SYMPTOMS:
                            if (this.checkboxNoOtherSymptoms != null) {
                                this.checkboxNoOtherSymptoms.$el.blur();
                            }
                            break;

                        case SQ_PANEL.SYMPTOMS_PANEL:
                        case SQ_PANEL.SHARED_QUESTIONS:
                            // We lost a panel with possible vSelect focused. Loose that focus
                            if (this.vSelectCrtQuestion != null) {

                                this.vSelectCrtQuestion.hideMenu();
                                this.vSelectCrtQuestion.$el.blur();

                                this.vSelectCrtQuestion = null;
                            }

                            this.shortcutNav.crtSymptom = null;
                            this.shortcutNav.crtQuestion = null;

                            break;
                    }

                }
            },

            navSetIsKeyboardNav(isNavigation) {

                if (this.shortcutNav.isKeyboardNav === false && isNavigation === true) {
                    this.navFocusPanelElement();
                }

                this.shortcutNav.isKeyboardNav = isNavigation;
            },

            // Scroll Into View

            navScrollIntoViewRelatedSymptom() {

                if (this.shortcutNav.crtRelatedSymptom === null) {
                    return;
                }

                let relatedSymptomPanel = document.querySelector('#RELATED_S_' + this.shortcutNav.crtRelatedSymptom);
                let containerScrollable = document.querySelector('.scrolling-content-symptoms-professional');
                containerScrollable.scrollTop = relatedSymptomPanel.offsetTop - 162;
            },

            navScrollIntoViewPanelOrSymptoms() {

                if (this.shortcutNav.crtPanel === SQ_PANEL.SYMPTOMS_PANEL) {

                    let currentSymptomIdx = this.navGetCurrentSymptomIdx();
                    if (currentSymptomIdx < 0) {
                        this.navSelectSymptom(0);
                    }
                    else if (this.shortcutNav.crtSymptom != null) {
                        let symptomPanel = document.querySelector('#v_card_' + this.shortcutNav.crtSymptom);
                        let containerScrollable = document.querySelector('.scrolling-content-symptoms-professional');
                        containerScrollable.scrollTop = symptomPanel.offsetTop - 10;
                    }
                }
                else {
                    let panel = document.querySelector('#' + this.shortcutNav.crtPanel);
                    let containerScrollable = document.querySelector('.scrolling-content-symptoms-professional');
                    containerScrollable.scrollTop = panel.offsetTop - 10;
                }
            },

            navScrollIntoViewCrtQuestion() {

                if (this.vSelectCrtQuestion != null && this.vSelectCrtQuestion.$el.offsetParent != null) {

                    let containerScrollable = document.querySelector('.scrolling-content-symptoms-professional');
                    containerScrollable.scrollTop = this.vSelectCrtQuestion.$el.offsetParent.offsetTop + this.vSelectCrtQuestion.$el.offsetTop - 120;
                }
            },

            // RELATED SYMPTOMS Panel

            navSelectRelatedSymptom(selectRelatedSymptomIdx) {

                if (this.relatedSymptomList.length === 0) {
                    return;
                }

                let relatedSymptom = this.relatedSymptomList[selectRelatedSymptomIdx];
                this.shortcutNav.crtRelatedSymptom = relatedSymptom.code;

                this.navFindCheckboxRelatedSymptom(true);
            },

            navGetCurrentRelatedSymptomIdx() {

                let currentSymptomIdx = -1;
                if (this.shortcutNav.crtRelatedSymptom != null) {
                    currentSymptomIdx = this.relatedSymptomList.findIndex((symptom, index) => {
                        if (symptom.code === this.shortcutNav.crtRelatedSymptom) {
                            return true;
                        }
                    });
                }
                return currentSymptomIdx;
            },

            navFindCheckboxRelatedSymptom(withFocus) {

                // Reset first the this.checkboxRelatedSymptom to don't keep an old reference to other checkbox
                this.checkboxRelatedSymptom = null;

                if (this.shortcutNav.crtRelatedSymptom === null) {
                    return;
                }

                let identifierSuffix;
                if (this.shortcutNav.crtRelatedSymptomYes === true) {
                    identifierSuffix = '_YES';
                }
                else {
                    identifierSuffix = '_NO';
                }

                if (this.$refs["symptomsQuestionsContentRef"] != null
                    && this.$refs["symptomsQuestionsContentRef"].$refs["relatedSymptomsRef"] != null
                    && this.$refs["symptomsQuestionsContentRef"].$refs["relatedSymptomsRef"].$refs['RELATED_SYMPTOM_' + this.shortcutNav.crtRelatedSymptom + identifierSuffix] != null
                    && this.$refs["symptomsQuestionsContentRef"].$refs["relatedSymptomsRef"].$refs['RELATED_SYMPTOM_' + this.shortcutNav.crtRelatedSymptom + identifierSuffix][0] != null) {

                    this.checkboxRelatedSymptom = this.$refs["symptomsQuestionsContentRef"].$refs["relatedSymptomsRef"].$refs['RELATED_SYMPTOM_' + this.shortcutNav.crtRelatedSymptom + identifierSuffix][0];

                    if (withFocus === true) {
                        this.checkboxRelatedSymptom.$el.focus();
                        this.navScrollIntoViewRelatedSymptom();
                    }
                }
            },

            // NO OTHER SYMPTOMS Panel

            navFindCheckboxNoOtherSymptoms(withFocus) {

                if (this.$refs["symptomsQuestionsContentRef"] != null
                    && this.$refs["symptomsQuestionsContentRef"].$refs["relatedSymptomsRef"] != null
                    && this.$refs["symptomsQuestionsContentRef"].$refs["relatedSymptomsRef"].$refs["noOtherSymptomsRef"] != null) {

                    this.checkboxNoOtherSymptoms = this.$refs["symptomsQuestionsContentRef"].$refs["relatedSymptomsRef"].$refs["noOtherSymptomsRef"];

                    if (withFocus === true) {
                        this.checkboxNoOtherSymptoms.$el.focus();
                    }
                }
            },

            // Symptoms Navigation

            navSymptomsDown() {

                let symptomsListLength = this.symptomList.length;

                let currentSymptomIdx = this.navGetCurrentSymptomIdx();
                if (currentSymptomIdx < 0) {
                    this.navSelectSymptom(0);
                    return;
                }

                if (this.$vuetify.breakpoint.lgAndUp) {
                    //We have 3 Symptoms at a row
                    let modulus = currentSymptomIdx % 3;

                    if (modulus === 2) {
                        if (currentSymptomIdx <= (symptomsListLength - 4)) {

                            this.navSelectSymptom(currentSymptomIdx + 3);
                        }
                        else if (currentSymptomIdx <= (symptomsListLength - 3)) {

                            this.navSelectSymptom(currentSymptomIdx + 2);
                        }
                        else if (currentSymptomIdx <= (symptomsListLength - 2)) {

                            this.navSelectSymptom(currentSymptomIdx + 1);
                        }
                        else if (currentSymptomIdx === (symptomsListLength - 1)) {

                            this.navSelectSymptom(2);
                        }

                    }
                    else if (modulus === 1) {
                        if (currentSymptomIdx <= (symptomsListLength - 4)) {

                            this.navSelectSymptom(currentSymptomIdx + 3);
                        }
                        else if (currentSymptomIdx <= (symptomsListLength - 3)) {

                            this.navSelectSymptom(currentSymptomIdx + 2);
                        }
                        else if (currentSymptomIdx <= (symptomsListLength - 1)) {

                            this.navSelectSymptom(1);
                        }
                    }
                    else if (modulus === 0) {
                        if (currentSymptomIdx <= (symptomsListLength - 4)) {

                            this.navSelectSymptom(currentSymptomIdx + 3);
                        }
                        else if (currentSymptomIdx <= (symptomsListLength - 1)) {

                            this.navSelectSymptom(0);
                        }
                    }
                }
                else if (this.$vuetify.breakpoint.mdOnly) {
                    //We have 2 Symptoms at a row
                    let modulus = currentSymptomIdx % 2;

                    if (modulus === 1) {
                        if (currentSymptomIdx <= (symptomsListLength - 3)) {

                            this.navSelectSymptom(currentSymptomIdx + 2);
                        }
                        else if (currentSymptomIdx <= (symptomsListLength - 2)) {

                            this.navSelectSymptom(currentSymptomIdx + 1);
                        }
                        else if (currentSymptomIdx === (symptomsListLength - 1)) {

                            this.navSelectSymptom(1);
                        }
                    }
                    else if (modulus === 0) {
                        if (currentSymptomIdx <= (symptomsListLength - 3)) {

                            this.navSelectSymptom(currentSymptomIdx + 2);
                        }
                        else if (currentSymptomIdx <= (symptomsListLength - 1)) {

                            this.navSelectSymptom(0);
                        }
                    }
                }
                else if (this.$vuetify.breakpoint.smAndDown) {
                    //We have 1 Symptom at a row + Shared Q at the bottom
                    if (currentSymptomIdx <= (symptomsListLength - 2)) {

                        this.navSelectSymptom(currentSymptomIdx + 1);
                    }
                    else {
                        this.navSelectPanelAndSharedQuestion(false);
                    }
                }
            },

            navSymptomsUp() {

                let symptomsListLength = this.symptomList.length;

                let currentSymptomIdx = this.navGetCurrentSymptomIdx();
                if (currentSymptomIdx < 0) {
                    this.navSelectSymptom(0);
                    return;
                }

                if (this.$vuetify.breakpoint.lgAndUp) {
                    //We have 3 Symptoms at a row
                    let modulus = currentSymptomIdx % 3;

/*
                    //(modulus === 0)
                    symptomsListLength - (((symptomsListLength - 1) % 3) + 1)

                    //L = 12 R = 0 R-1 = 2
                    symptomsListLength - 3
                    //L = 11 R = 2 R-1 = 1
                    symptomsListLength - 2
                    //L = 10 R = 1 R-1 = 0
                    symptomsListLength - 1


                    //(modulus === 1)
                    symptomsListLength - (((symptomsListLength - 2) % 3) + 1)

                    //L=12 R=0 R-1=2 R-2=1
                    symptomsListLength - 2 (1)
                    //L=11 R=2 R-1=1 R-2=0
                    symptomsListLength - 1 (0)
                    //L=10 R=1 R-1=0 R-2=2
                    symptomsListLength - 3 (2)


                    //(modulus === 2)
                    symptomsListLength - ((symptomsListLength % 3) + 1)

                    //L = 12 R = 0 R-1 = 2
                    symptomsListLength - 1
                    //L = 11 R = 2 R-1 = 1
                    symptomsListLength - 3
                    //L = 10 R = 1 R-1 = 0
                    symptomsListLength - 2

*/

                    if (modulus === 0) {

                        if (currentSymptomIdx >= 3) {

                            this.navSelectSymptom(currentSymptomIdx - 3);
                        }
                        else {
                            let lastIndexOfTheColumn = symptomsListLength - (((symptomsListLength - 1) % 3) + 1);
                            if (lastIndexOfTheColumn >= 0) {
                                this.navSelectSymptom(lastIndexOfTheColumn);
                            }
                        }
                    }
                    else if (modulus === 1) {

                        if (currentSymptomIdx >= 4) {

                            this.navSelectSymptom(currentSymptomIdx - 3);
                        }
                        else {
                            let lastIndexOfTheColumn = symptomsListLength - (((symptomsListLength - 2) % 3) + 1);
                            if (lastIndexOfTheColumn >= 0) {
                                this.navSelectSymptom(lastIndexOfTheColumn);
                            }
                        }
                    }
                    else if (modulus === 2) {

                        if (currentSymptomIdx >= 5) {

                            this.navSelectSymptom(currentSymptomIdx - 3);
                        }
                        else {
                            let lastIndexOfTheColumn = symptomsListLength - ((symptomsListLength % 3) + 1);
                            if (lastIndexOfTheColumn >= 0) {
                                this.navSelectSymptom(lastIndexOfTheColumn);
                            }
                        }
                    }
                }
                else if (this.$vuetify.breakpoint.mdOnly) {
                    //We have 2 Symptoms at a row
                    let modulus = currentSymptomIdx % 2;

/*
                    //(modulus === 0)
                    symptomsListLength - (((symptomsListLength - 1) % 2) + 1)

                    //L = 12 R = 0 R-1 = 1
                    symptomsListLength - 2 (1)
                    //L = 11 R = 1 R-1 = 0
                    symptomsListLength - 1 (0)


                    //(modulus === 1)
                    symptomsListLength - ((symptomsListLength % 2) + 1)

                    //L=12 R=0 R-1=1
                    symptomsListLength - 1 (0)
                    //L=11 R=1 R-1=0
                    symptomsListLength - 2 (1)
*/


                    if (modulus === 0) {
                        if (currentSymptomIdx >= 2) {

                            this.navSelectSymptom(currentSymptomIdx - 2);
                        }
                        else {
                            let lastIndexOfTheColumn = symptomsListLength - (((symptomsListLength - 1) % 2) + 1);
                            if (lastIndexOfTheColumn >= 0) {
                                this.navSelectSymptom(lastIndexOfTheColumn);
                            }
                        }
                    }
                    else if (modulus === 1) {
                        if (currentSymptomIdx >= 3) {

                            this.navSelectSymptom(currentSymptomIdx - 2);
                        }
                        else {
                            let lastIndexOfTheColumn = symptomsListLength - ((symptomsListLength % 2) + 1);
                            if (lastIndexOfTheColumn >= 0) {
                                this.navSelectSymptom(lastIndexOfTheColumn);
                            }
                        }
                    }
                }
                else if (this.$vuetify.breakpoint.smOnly) {
                    //We have 1 Symptom at a row + Shared Q at the bottom
                    if (currentSymptomIdx >= 1) {

                        this.navSelectSymptom(currentSymptomIdx - 1);
                    }
                    else {
                        this.navSelectPanelAndSharedQuestion(false);
                    }
                }
                else if (this.$vuetify.breakpoint.xsOnly) {
                    //We have Related Symptoms, possible NoOtherSymptoms, 1 Symptom at a row + Shared Q at the bottom
                    if (currentSymptomIdx >= 1) {

                        this.navSelectSymptom(currentSymptomIdx - 1);
                    }
                    else {
                        if (this.noOtherSymptomsCheck === true) {
                            this.navSetShortcutNavCrtPanel(SQ_PANEL.NO_OTHER_SYMPTOMS, true);
                        }
                        else {
                            this.navSetShortcutNavCrtPanel(SQ_PANEL.RELATED_SYMPTOMS, true);
                        }
                    }
                }
            },

            navSymptomsRight() {

                let symptomsListLength = this.symptomList.length;

                let currentSymptomIdx = this.navGetCurrentSymptomIdx();
                if (currentSymptomIdx < 0) {
                    this.navSelectSymptom(0);
                    return;
                }

                if (this.$vuetify.breakpoint.lgAndUp) {
                    //We have 3 Symptoms at a row
                    let modulus = currentSymptomIdx % 3;

                    if (modulus === 0 || modulus === 1) {
                        if (currentSymptomIdx <= (symptomsListLength - 2)) {

                            this.navSelectSymptom(currentSymptomIdx + 1);
                        }
                        else if (currentSymptomIdx === (symptomsListLength - 1)) {

                            this.navSelectPanelAndSharedQuestion(false);
                        }
                    }
                    else if (modulus === 2) {
                        this.navSelectPanelAndSharedQuestion(false);
                    }
                }
                else if (this.$vuetify.breakpoint.mdOnly) {
                    //We have 2 Symptoms at a row
                    let modulus = currentSymptomIdx % 2;

                    if (modulus === 0) {
                        if (currentSymptomIdx <= (symptomsListLength - 2)) {

                            this.navSelectSymptom(currentSymptomIdx + 1);
                        }
                        else {
                            this.navSelectPanelAndSharedQuestion(false);
                        }
                    }
                    else if (modulus === 1) {
                        this.navSelectPanelAndSharedQuestion(false);
                    }
                }
                else if (this.$vuetify.breakpoint.smAndDown) {
                    //We have 1 Symptom at a row + Shared Q at the bottom
                    this.navSetShortcutNavCrtPanel(SQ_PANEL.RELATED_SYMPTOMS, true);
                }
            },

            navSymptomsLeft() {

                let currentSymptomIdx = this.navGetCurrentSymptomIdx();
                if (currentSymptomIdx < 0) {
                    this.navSelectSymptom(0);
                    return;
                }

                if (this.$vuetify.breakpoint.lgAndUp) {
                    //We have 3 Symptoms at a row
                    let modulus = currentSymptomIdx % 3;

                    if (modulus === 0) {
                        this.navSetShortcutNavCrtPanel(SQ_PANEL.RELATED_SYMPTOMS, true);
                    }
                    else if (modulus === 1 || modulus === 2) {
                        if (currentSymptomIdx >= 1) {
                           this.navSelectSymptom(currentSymptomIdx - 1);
                        }
                    }
                }
                else if (this.$vuetify.breakpoint.mdOnly) {
                    //We have 2 Symptoms at a row
                    let modulus = currentSymptomIdx % 2;

                    if (modulus === 0) {
                        this.navSetShortcutNavCrtPanel(SQ_PANEL.RELATED_SYMPTOMS, true);
                    }
                    else if (modulus === 1) {
                        if (currentSymptomIdx >= 1) {
                            this.navSelectSymptom(currentSymptomIdx - 1);
                        }
                    }
                }
            },

            navSymptomsMdAndUpBottom() {

                let symptomsListLength = this.symptomList.length;

                let currentSymptomIdx = this.navGetCurrentSymptomIdx();
                if (currentSymptomIdx < 0) {
                    this.navSelectSymptom(0);
                    return;
                }

                if (this.$vuetify.breakpoint.lgAndUp) {
                    //We have 3 Symptoms at a row
                    let modulus = currentSymptomIdx % 3;

                    let bottomModulus = (symptomsListLength - 1) % 3;

                    // 3 columns, current column = 3
                    if (modulus === 2) {

                        if (bottomModulus === 2) {
                            this.navSelectSymptom(symptomsListLength - 1);
                        }
                        else if (bottomModulus === 1) {
                            this.navSelectSymptom((symptomsListLength - 1) - 2);
                        }
                        else if (bottomModulus === 0) {
                            this.navSelectSymptom((symptomsListLength - 1) - 1);
                        }
                    }
                    // 3 columns, current column = 2
                    else if (modulus === 1) {

                        if (bottomModulus === 2) {
                            this.navSelectSymptom((symptomsListLength - 1) - 1);
                        }
                        else if (bottomModulus === 1) {
                            this.navSelectSymptom(symptomsListLength - 1);
                        }
                        else if (bottomModulus === 0) {
                            this.navSelectSymptom((symptomsListLength - 1) - 2);
                        }
                    }
                    // 3 columns, current column = 1
                    else if (modulus === 0) {

                        if (bottomModulus === 2) {
                            this.navSelectSymptom((symptomsListLength - 1) - 2);
                        }
                        else if (bottomModulus === 1) {
                            this.navSelectSymptom((symptomsListLength - 1) - 1);
                        }
                        else if (bottomModulus === 0) {
                            this.navSelectSymptom(symptomsListLength - 1);
                        }
                    }
                }
                else if (this.$vuetify.breakpoint.mdOnly) {
                    //We have 2 Symptoms at a row
                    let modulus = currentSymptomIdx % 2;

                    let bottomModulus = (symptomsListLength - 1) % 2;

                    // 2 columns, current column = 2
                    if (modulus === 1) {

                        if (bottomModulus === 1) {
                            this.navSelectSymptom(symptomsListLength - 1);
                        }
                        else if (bottomModulus === 0) {
                            this.navSelectSymptom((symptomsListLength - 1) - 1);
                        }
                    }
                    // 2 columns, current column = 1
                    else if (modulus === 0) {

                        if (bottomModulus === 1) {
                            this.navSelectSymptom((symptomsListLength - 1) - 1);
                        }
                        else if (bottomModulus === 0) {
                            this.navSelectSymptom(symptomsListLength - 1);
                        }
                    }
                }
            },

            navSymptomsMdAndUpTop() {

                let currentSymptomIdx = this.navGetCurrentSymptomIdx();
                if (currentSymptomIdx < 0) {
                    this.navSelectSymptom(0);
                    return;
                }

                if (this.$vuetify.breakpoint.lgAndUp) {
                    //We have 3 Symptoms at a row
                    let modulus = currentSymptomIdx % 3;

                    // 3 columns, current column = 3
                    if (modulus === 2) {
                        this.navSelectSymptom(2);
                    }
                    // 3 columns, current column = 2
                    else if (modulus === 1) {
                        this.navSelectSymptom(1);
                    }
                    // 3 columns, current column = 1
                    else if (modulus === 0) {
                        this.navSelectSymptom(0);
                    }
                }
                else if (this.$vuetify.breakpoint.mdOnly) {
                    //We have 2 Symptoms at a row
                    let modulus = currentSymptomIdx % 2;

                    // 2 columns, current column = 2
                    if (modulus === 1) {
                        this.navSelectSymptom(1);
                    }
                    // 2 columns, current column = 1
                    else if (modulus === 0) {
                        this.navSelectSymptom(0);
                    }
                }
            },

            // Specific Questions Navigation

            navSpecificQuestionsDown() {

                let currentSymptomIdx = this.navGetCurrentSymptomIdx();
                if (currentSymptomIdx < 0) {
                    this.navSelectSymptom(0);
                    return;
                }

                let symptom = this.symptomList[currentSymptomIdx];
                let symptomQuestionList = symptom.questionsData.questions;

                if (symptomQuestionList.length === 0) {
                    return;
                }

                let currentQuestionIdx = symptomQuestionList.findIndex((currentQuestion, currentIndex) => {
                    if (currentQuestion.code === this.shortcutNav.crtQuestion) {
                        return true;
                    }
                });

                if (currentQuestionIdx < 0 || currentQuestionIdx === (symptomQuestionList.length - 1)) {
                    this.navSelectSymptomAndQuestion(currentSymptomIdx, 0, true);
                }
                else {
                    this.navSelectSymptomAndQuestion(currentSymptomIdx, currentQuestionIdx + 1, true);
                }
            },

            navSpecificQuestionsUp() {

                let currentSymptomIdx = this.navGetCurrentSymptomIdx();
                if (currentSymptomIdx < 0) {
                    this.navSelectSymptom(0);
                    return;
                }

                let symptom = this.symptomList[currentSymptomIdx];
                let symptomQuestionList = symptom.questionsData.questions;

                if (symptomQuestionList.length === 0) {
                    return;
                }

                let currentQuestionIdx = symptomQuestionList.findIndex((currentQuestion, currentIndex) => {
                    if (currentQuestion.code === this.shortcutNav.crtQuestion) {
                        return true;
                    }
                });

                if (currentQuestionIdx < 0) {
                    this.navSelectSymptomAndQuestion(currentSymptomIdx, 0, true);
                }
                else if (currentQuestionIdx === 0) {
                    this.navSelectSymptomAndQuestion(currentSymptomIdx, symptomQuestionList.length - 1, true);
                }
                else {
                    this.navSelectSymptomAndQuestion(currentSymptomIdx, currentQuestionIdx - 1, true);
                }
            },

            navSpecificQuestionsBottom() {

                let currentSymptomIdx = this.navGetCurrentSymptomIdx();
                if (currentSymptomIdx < 0) {
                    this.navSelectSymptom(0);
                    return;
                }

                let symptom = this.symptomList[currentSymptomIdx];
                let symptomQuestionList = symptom.questionsData.questions;

                if (symptomQuestionList.length === 0) {
                    return;
                }

                this.navSelectSymptomAndQuestion(currentSymptomIdx, symptomQuestionList.length - 1, true);
            },

            navSpecificQuestionsTop() {

                let currentSymptomIdx = this.navGetCurrentSymptomIdx();
                if (currentSymptomIdx < 0) {
                    this.navSelectSymptom(0);
                    return;
                }

                let symptom = this.symptomList[currentSymptomIdx];
                let symptomQuestionList = symptom.questionsData.questions;

                if (symptomQuestionList.length === 0) {
                    return;
                }

                this.navSelectSymptomAndQuestion(currentSymptomIdx, 0, true);
            },

            // Shared Questions Navigation

            navSharedQuestionsDown() {

                if (this.sharedQuestionList.length === 0) {
                    return;
                }

                let currentQuestionIdx = this.sharedQuestionList.findIndex((currentQuestion, currentIndex) => {
                    if (currentQuestion.code === this.shortcutNav.crtQuestion) {
                        return true;
                    }
                });

                if (currentQuestionIdx < 0 || currentQuestionIdx === (this.sharedQuestionList.length - 1)) {
                    this.navSelectSharedQuestion(0, true);
                }
                else {
                    this.navSelectSharedQuestion(currentQuestionIdx + 1, true);
                }
            },

            navSharedQuestionsUp() {

                if (this.sharedQuestionList.length === 0) {
                    return;
                }

                let currentQuestionIdx = this.sharedQuestionList.findIndex((currentQuestion, currentIndex) => {
                    if (currentQuestion.code === this.shortcutNav.crtQuestion) {
                        return true;
                    }
                });

                if (currentQuestionIdx < 0) {
                    this.navSelectSharedQuestion(0, true);
                }
                else if (currentQuestionIdx === 0) {
                    this.navSelectSharedQuestion(this.sharedQuestionList.length - 1, true);
                }
                else {
                    this.navSelectSharedQuestion(currentQuestionIdx - 1, true);
                }
            },

            navSharedQuestionsBottom() {

                if (this.sharedQuestionList.length === 0) {
                    return;
                }

                this.navSelectSharedQuestion(this.sharedQuestionList.length - 1, true);
            },

            navSharedQuestionsTop() {

                if (this.sharedQuestionList.length === 0) {
                    return;
                }

                this.navSelectSharedQuestion(0, true);
            },

            // SYMPTOMS Panels

            navSelectSymptomAndQuestion(selectSymptomIdx, selectQuestionIdx, isScrollIntoViewQuestion) {

                let symptom = this.symptomList[selectSymptomIdx];

                // Test if is a new Symptoms. If it is, scroll to it
                let isScrollIntoView = (this.shortcutNav.crtSymptom !== symptom.code);

                // Set it twice, here and bellow, because is set to null inside navSetShortcutNavCrtPanel() call
                // when change panels from ShQ to SpQ due to onChangeAnswer() call
                this.shortcutNav.crtSymptom = symptom.code;

                this.navSetShortcutNavCrtPanel(SQ_PANEL.SYMPTOMS_PANEL, isScrollIntoView);

                // Set it twice, here and above, because is set to null inside navSetShortcutNavCrtPanel() call
                // when change panels from ShQ to SpQ due to onChangeAnswer() call
                this.shortcutNav.crtSymptom = symptom.code;

                if (symptom.questionsData.questions.length === 0) {
                    return;
                }

                this.shortcutNav.crtQuestion = symptom.questionsData.questions[selectQuestionIdx].code;

                this.navSetVSelectCrtQuestionForSpecificQ();

                if (this.vSelectCrtQuestion != null && isScrollIntoViewQuestion === true) {
                    this.vSelectCrtQuestion.$el.focus();
                    this.navScrollIntoViewCrtQuestion();
                }

            },

            navSetVSelectCrtQuestionForSpecificQ() {

                if (this.$refs["symptomsQuestionsContentRef"] != null
                    && this.$refs["symptomsQuestionsContentRef"].$refs["symptomsPanelsRef"] != null
                    && this.$refs["symptomsQuestionsContentRef"].$refs["symptomsPanelsRef"].$refs['questionListBlockRef_' + this.shortcutNav.crtSymptom] != null
                    && this.$refs["symptomsQuestionsContentRef"].$refs["symptomsPanelsRef"].$refs['questionListBlockRef_' + this.shortcutNav.crtSymptom][0] != null
                    && this.$refs["symptomsQuestionsContentRef"].$refs["symptomsPanelsRef"].$refs['questionListBlockRef_' + this.shortcutNav.crtSymptom][0].$refs['symptomQuestionItemRef_' + this.shortcutNav.crtQuestion] != null
                    && this.$refs["symptomsQuestionsContentRef"].$refs["symptomsPanelsRef"].$refs['questionListBlockRef_' + this.shortcutNav.crtSymptom][0].$refs['symptomQuestionItemRef_' + this.shortcutNav.crtQuestion][0] != null
                    && this.$refs["symptomsQuestionsContentRef"].$refs["symptomsPanelsRef"].$refs['questionListBlockRef_' + this.shortcutNav.crtSymptom][0].$refs['symptomQuestionItemRef_' + this.shortcutNav.crtQuestion][0].$refs['question-dropdown-' + this.shortcutNav.crtQuestion] != null) {

                    this.vSelectCrtQuestion = this.$refs["symptomsQuestionsContentRef"].$refs["symptomsPanelsRef"].$refs['questionListBlockRef_' + this.shortcutNav.crtSymptom][0].$refs['symptomQuestionItemRef_' + this.shortcutNav.crtQuestion][0].$refs['question-dropdown-' + this.shortcutNav.crtQuestion];
                }
            },

            navSetVSelectCrtQuestionForSharedQ() {

                if (this.$refs["symptomsQuestionsContentRef"] != null
                    && this.$refs["symptomsQuestionsContentRef"].$refs["sharedQuestionsRef"] != null
                    && this.$refs["symptomsQuestionsContentRef"].$refs["sharedQuestionsRef"].$refs['questionListBlockRef'] != null
                    && this.$refs["symptomsQuestionsContentRef"].$refs["sharedQuestionsRef"].$refs['questionListBlockRef'].$refs['symptomQuestionItemRef_' + this.shortcutNav.crtQuestion] != null
                    && this.$refs["symptomsQuestionsContentRef"].$refs["sharedQuestionsRef"].$refs['questionListBlockRef'].$refs['symptomQuestionItemRef_' + this.shortcutNav.crtQuestion][0] != null
                    && this.$refs["symptomsQuestionsContentRef"].$refs["sharedQuestionsRef"].$refs['questionListBlockRef'].$refs['symptomQuestionItemRef_' + this.shortcutNav.crtQuestion][0].$refs['question-dropdown-' + this.shortcutNav.crtQuestion] != null) {

                    this.vSelectCrtQuestion = this.$refs["symptomsQuestionsContentRef"].$refs["sharedQuestionsRef"].$refs['questionListBlockRef'].$refs['symptomQuestionItemRef_' + this.shortcutNav.crtQuestion][0].$refs['question-dropdown-' + this.shortcutNav.crtQuestion];
                }
            },

            navSelectSymptom(selectSymptomIdx) {

                let selectQuestionIdx = -1;

                let symptom = this.symptomList[selectSymptomIdx];
                let symptomQuestionList = symptom.questionsData.questions;

                if (symptomQuestionList.length > 0) {
                    selectQuestionIdx = symptomQuestionList.findIndex((currentQuestion, currentIndex) => {
                        if (currentQuestion.providedAnswer === null) {
                            return true;
                        }
                    });
                }

                if (selectQuestionIdx < 0) {
                    selectQuestionIdx = 0;
                }

                this.navSelectSymptomAndQuestion(selectSymptomIdx, selectQuestionIdx, false);
            },

            // SHARED QUESTIONS Panel

            navSelectPanelAndSharedQuestion(isScrollIntoViewQuestion, sharedQuestionIdx) {

                this.navSetShortcutNavCrtPanel(SQ_PANEL.SHARED_QUESTIONS, true);

                if (this.sharedQuestionList.length === 0) {
                    return;
                }

                if (typeof sharedQuestionIdx !== "undefined" && sharedQuestionIdx >= 0) {
                    this.navSelectSharedQuestion(sharedQuestionIdx, isScrollIntoViewQuestion);
                }
                else {
                    let firstUnansweredShQIdx = this.sharedQuestionList.findIndex((currentQuestion, crtIndex) => {
                        if (currentQuestion.providedAnswer === null) {
                            return true;
                        }
                    });

                    if (firstUnansweredShQIdx >= 0) {
                        this.navSelectSharedQuestion(firstUnansweredShQIdx, isScrollIntoViewQuestion);
                    }
                    else {
                        this.navSelectSharedQuestion(0, isScrollIntoViewQuestion);
                    }
                }
            },

            navSelectSharedQuestion(selectQuestionIdx, isScrollIntoView) {

                if (this.sharedQuestionList.length === 0) {
                    return;
                }

                this.shortcutNav.crtQuestion = this.sharedQuestionList[selectQuestionIdx].code;

                this.navSetVSelectCrtQuestionForSharedQ();

                if (this.vSelectCrtQuestion != null && isScrollIntoView === true) {
                    this.vSelectCrtQuestion.$el.focus();
                    this.navScrollIntoViewCrtQuestion();
                }

            },

            navGetCurrentSymptomIdx() {

                let currentSymptomIdx = -1;
                if (this.shortcutNav.crtSymptom != null) {
                    currentSymptomIdx = this.symptomList.findIndex((symptom, index) => {
                        if (symptom.code === this.shortcutNav.crtSymptom) {
                            return true;
                        }
                    });
                }
                return currentSymptomIdx;
            },

            navSelectSymptomsWithFirstUnansweredQ() {

                // Return to SpQ and search if there are still not answered Q
                let firstUnansweredSpQArr = this.navGetFirstUnansweredSpQ();

                if (firstUnansweredSpQArr != null) {

                    this.navSelectSymptomAndQuestion(firstUnansweredSpQArr[0], firstUnansweredSpQArr[1], true);
                }
                else {
                    //Stay on the last answered
                }
            },

            navGetFirstUnansweredSpQ(currentSymptomIdx) {

                let firstUnansweredQIdx = -1;
                let symptomWithNotAnsweredQIdx = this.symptomList.findIndex((crtSymptom, index) => {

                    // Ignore before Questions
                    if (typeof currentSymptomIdx !== "undefined" && currentSymptomIdx >= index) {
                        return false;
                    }

                    let symptomQuestionList = crtSymptom.questionsData.questions;
                    if (symptomQuestionList.length >= 0) {

                        firstUnansweredQIdx = symptomQuestionList.findIndex((currentQuestion, crtIndex) => {
                            if (currentQuestion.providedAnswer === null) {
                                return true;
                            }
                        });

                        return (firstUnansweredQIdx >= 0);
                    }
                    else {
                        return false;
                    }
                });

                if (symptomWithNotAnsweredQIdx >= 0 && firstUnansweredQIdx >= 0) {

                    return [symptomWithNotAnsweredQIdx, firstUnansweredQIdx];
                }
                else {
                    return null;
                }
            },

            navSelectFirstShQOrFirstUnansweredSpQFromBegining() {

                // We are on the last Symptom from the list. Search unanswered Q into Shared Questions panel
                let firstUnansweredShQIdx = this.sharedQuestionList.findIndex((currentQuestion, crtIndex) => {
                    if (currentQuestion.providedAnswer === null) {
                        return true;
                    }
                });

                if (firstUnansweredShQIdx >= 0) {
                    this.navSelectPanelAndSharedQuestion(true, firstUnansweredShQIdx);
                }
                else {
                    this.navSelectSymptomsWithFirstUnansweredQ();
                }
            },

            navGotoFirstPage() {
                if(!this.getMustShowAssessmentList) {
                    this.$router.push('/assessment-start');
                } else {
                    this.$router.push('/assessment-start-list');
                }
            }

            /*******************************
             ***   KEYBOARD NAVIGATION   ***
             ***        END CODE         ***
             *******************************/

        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .container-symptoms-questions.grid-list-xl {

        .page-content{
            margin-top: 40px;

        }

        .related-symptoms {

            .related {
                padding: 0 20px 30px;
            }
        }

        .selected-symptoms {
            padding: 12px 0;


            .shared-questions {
                padding-left: 20px;
            }
        }
    }

    .btn-menu {
        max-width: 50px;
        margin-right: 50px;

        .settings {
            width: 15%;
        }
    }

    .btn-logout {
        max-width: 50px;
        margin-right: 50px;
    }

    .toolbar--fixed.header {
        background-color: $color-on-primary;
        padding: 0 20px;
        overflow: hidden;
        box-shadow: none;
        border-bottom: 3px solid $color-gray-lightest;
    }

    .user {
        width: 8%;
        margin-right: 10px;
    }

    .top-bar-no-margin{
        height: 50px;
    }
    .alerts-top {
        display: inline-flex;
    }

</style>



// WEBPACK FOOTER //
// src/professional/components/symptoms-questions/symptoms-panels/SymptomsQuestionsPage.vue